import type { Property, PropertyValue } from "../models";

const combineProperties = (props: PropertyValue[], catalogProps: Map<string, Property>): Property[] => {
	const catalogOrder = new Map(Array.from(catalogProps.keys()).map((id, index) => [id, index]));
	const combinedProperties = props?.map((prop) => {
		const originalProp = catalogProps.get(prop?.id);
		if (!originalProp) return prop as Property;
		const value = Array.isArray(prop?.value) ? prop?.value : [prop?.value];
		return { ...originalProp, value: prop.value ? [...value] : undefined };
	});

	return combinedProperties?.sort((first, second) => {
		const firstIndex = catalogOrder.get(first.id) ?? catalogOrder.size;
		const secondIndex = catalogOrder.get(second.id) ?? catalogOrder.size;
		return firstIndex - secondIndex;
	});
};

export default combineProperties;
